// extracted by mini-css-extract-plugin
export const about = "D_b9";
export const about_descr = "D_cb";
export const about_btns = "D_cc";
export const about_btn = "D_cd";